import React from 'react';

// Sidwell Logo Mark (icon mark): the signature serif "S" on the curtain-wall tile.
// Used in the Header and app icons where a compact brand mark is preferred over
// the full spelled-out wordmark.
export function LogoMark({ className = 'h-9 w-9', size = 36 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 189 189"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Sidwell"
    >
      <rect width="189" height="189" rx="4" fill="#10202B" />
      <path
        d="M98.44 152.76C94.1733 152.76 90.28 152.067 86.76 150.68C83.3467 149.293 80.2533 147.907 77.48 146.52C75.1333 145.24 73.16 144.28 71.56 143.64C70.0667 143 68.7333 142.68 67.56 142.68C66.0667 142.68 65 143.32 64.36 144.6C63.8267 145.773 63.4 147.107 63.08 148.6L62.6 151H58.6L59.4 132.12L58.92 111.48H62.92L64.68 119C65.8533 123.693 67.9333 128.28 70.92 132.76C74.0133 137.24 77.8533 140.92 82.44 143.8C87.1333 146.68 92.4667 148.12 98.44 148.12C101.747 148.12 104.893 147.427 107.88 146.04C110.973 144.547 113.48 142.307 115.4 139.32C117.427 136.333 118.44 132.44 118.44 127.64C118.44 122.84 117.373 118.733 115.24 115.32C113.213 111.8 110.227 108.653 106.28 105.88C102.44 103.107 97.7467 100.44 92.2 97.88L85.48 94.68C77.48 90.84 71.5067 86.6267 67.56 82.04C63.72 77.3467 61.8 71.3733 61.8 64.12C61.8 58.4667 63.1867 53.4533 65.96 49.08C68.7333 44.7067 72.52 41.2933 77.32 38.84C82.2267 36.3867 87.8267 35.16 94.12 35.16C98.4933 35.16 102.173 35.7467 105.16 36.92C108.147 38.0933 110.493 39.1067 112.2 39.96C114.973 41.3467 117.16 42.04 118.76 42.04C120.467 42.04 121.48 40.3867 121.8 37.08H125.8L125.32 52.44L125.64 67.96H121.64C121 61.9867 119.347 56.92 116.68 52.76C114.013 48.4933 110.76 45.24 106.92 43C103.187 40.76 99.1867 39.64 94.92 39.64C88.6267 39.64 83.5067 41.4533 79.56 45.08C75.72 48.7067 73.8 53.3467 73.8 59C73.8 65.08 75.7733 69.88 79.72 73.4C83.6667 76.8133 88.7867 80.0667 95.08 83.16L101.64 86.36C107.507 89.24 112.52 92.2267 116.68 95.32C120.947 98.3067 124.2 101.827 126.44 105.88C128.787 109.933 129.96 115 129.96 121.08C129.96 127.373 128.52 132.92 125.64 137.72C122.867 142.52 119.08 146.253 114.28 148.92C109.587 151.48 104.307 152.76 98.44 152.76Z"
        fill="#F5F2EC"
      />
    </svg>
  );
}

// The Sidwell wordmark: serif small caps with the red bar. The artwork is white, so there are two
// files (public/brand): dark ink for light grounds (the default) and the original white for dark ones.
export function WordmarkLogo({ className = '', onDark = false }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/brand/sidwell-wordmark-on-${onDark ? 'dark' : 'light'}.png`}
      width="462"
      height="96"
      alt="Sidwell"
      decoding="async"
      className={className}
    />
  );
}

// Default export supports variant: "mark" (icon mark) or "wordmark" (spelled out).
function Logo({ variant = 'wordmark', className = '', size = 36 }) {
  if (variant === 'mark') {
    return <LogoMark className={className} size={size} />;
  }
  return <WordmarkLogo className={className} />;
}

export default Logo;
